import React from "react"
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

const YesNoModal = props => {

    const {onCancel, onConfirm} = props;

    const handleCancel = () => {
        if (onCancel) onCancel();
    }

    const handleConfirm = () => {
        if (onConfirm) onConfirm();
    }

    return (
        <Window 
            resizable={false}
            modal={true}
            draggable={true}
            maximizeButton={EmptyButton}
            minimizeButton={EmptyButton}
            {...props}
        >
            {!!props.prompt && <div>{props.prompt}</div>}
            {!!props.secondPrompt && <><br/><br/><div><strong>{props.secondPrompt}</strong></div></>}
            <WindowActionsBar >
                <Button type="button" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button type="button" onClick={handleConfirm}>
                    Confirm
                </Button>
            </WindowActionsBar>
        </Window>
    )
}

const EmptyButton = () => { return <></>}

export default YesNoModal;



